import api from './client';

export interface UrgencyScarcitySettings {
  enabled: boolean;
  low_stock_enabled: boolean;
  low_stock_threshold: number;
  low_stock_message: string;
  countdown_enabled: boolean;
  countdown_end_at: string | null;
  countdown_message: string;
  countdown_expired_message: string;
}

export const urgencyScarcityApi = {
  show: () => api.get<{ data: UrgencyScarcitySettings }>('/urgency-scarcity'),

  update: (settings: UrgencyScarcitySettings) =>
    api.put<{ data: UrgencyScarcitySettings }>('/urgency-scarcity', settings),
};
